import { createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  root: {
    marginTop: '84px',
    marginLeft: '20px',
    position: 'relative',
  },
  spinner: {
    marginTop: '16px',
  },
  previewImg: {
    width: '325px',
    marginTop: '20px',
    display: 'block',
  },
});
